/* export const localhost = 'https://cos-app-backend-production.up.railway.app';
 */

export const localhost =
  'https://cos-app-backend-production-99c0.up.railway.app';
